export default __webpack_public_path__ + "static/media/interactiveKiosk.291f302c.svg";